/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornothingrecognised3Inputs */

const en_menueditornothingrecognised3 = /** @type {(inputs: Menueditornothingrecognised3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No dishes recognised – enter them yourself.`)
};

const de_menueditornothingrecognised3 = /** @type {(inputs: Menueditornothingrecognised3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Gerichte erkannt – trag sie selbst ein.`)
};

/**
* | output |
* | --- |
* | "No dishes recognised – enter them yourself." |
*
* @param {Menueditornothingrecognised3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornothingrecognised3 = /** @type {((inputs?: Menueditornothingrecognised3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornothingrecognised3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornothingrecognised3(inputs)
	return de_menueditornothingrecognised3(inputs)
});
export { menueditornothingrecognised3 as "menuEditorNothingRecognised" }